export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vyhledávání"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknutím vyberte, které sloupce chcete zobrazit"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zobrazené sloupce"])}
}